//export const BASE_URL =  "http://localhost";
//export const BASE_URL = "http://103.139.244.147:4005" ;
export const BASE_URL = "https://api-cetung.tirtahita.my.id" ;

export const API_BASE_URL = `${BASE_URL}/api`;

export const ODATA_BASE_URL = `${BASE_URL}/odata`;
